import styled from '@emotion/styled'

export const Wrapper = styled.div`
  margin-bottom: 1em;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .5em;
`

export const Label = styled.label`
  display: block;
`

export const Switch = styled.button`
  font: inherit;
  color: inherit;
  width: 4em;
  min-width: 4em;
  height: 2em;
  box-sizing: border-box;
  background: none;
  border: 2px solid currentColor;
  margin: 0;
  padding: 0;
  position: relative;
  border-radius: 10em;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    height: calc(1.6em - 4px);
    width: 2em;
    background: currentColor;
    border-radius: inherit;
    top: .2em;
    left: .2em;
  }
  &[aria-checked=true] {
    background: currentColor;

    &::after {
      background: ${props => props.theme.background};
      left: initial;
      right: .2em;
    }
  }
`